export default "__VITE_ASSET__CA2CIyx3__"